/**
 * Le repère anonyme de l'appareil qui ouvre la page d'un client.
 *
 * <p>Tiré au sort une fois et gardé dans la mémoire du téléphone, il revient
 * avec chaque ouverture et chaque téléchargement : un autre appareil a un autre
 * repère, et le patron voit que le lien a été transmis. Rien d'autre n'en est
 * tiré ; sans mémoire disponible (navigation privée), il n'y en a pas.
 */

const CLE = 'swisstech-visiteur';
const SIGNES = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

/**
 * @returns {string|null} le repère de cet appareil, créé à la première visite
 */
export function repereVisiteur() {
  try {
    const garde = window.localStorage.getItem(CLE);
    if (garde && /^[A-Za-z0-9]{24}$/.test(garde)) return garde;
    const octets = new Uint8Array(24);
    window.crypto.getRandomValues(octets);
    const repere = Array.from(octets, (o) => SIGNES[o % SIGNES.length]).join('');
    window.localStorage.setItem(CLE, repere);
    return repere;
  } catch {
    return null;
  }
}
